import { render } from "./configure-sftp-connection.vue?vue&type=template&id=4f08d506"
import script from "./configure-sftp-connection.vue?vue&type=script&setup=true&lang=js"
export * from "./configure-sftp-connection.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/integrations/pages/link-marketplace/components/noon/configure-sftp-connection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f08d506"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f08d506', __exports__)) {
    console.log('reload')
    api.reload('4f08d506', __exports__)
  }
  
  module.hot.accept("./configure-sftp-connection.vue?vue&type=template&id=4f08d506", () => {
    console.log('re-render')
    api.rerender('4f08d506', render)
  })

}


export default __exports__